import { DEFAULT_HEIGHT } from '../Charts';
import { css, SerializedStyles } from '@emotion/react';

export const tableStyles = (): SerializedStyles =>
    css({
        height: `${DEFAULT_HEIGHT}px`,
    });
